var _rect, _ellipse, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDisabledVideo = function SvgDisabledVideo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.619141,
    y: 4.7,
    width: 28.7609,
    height: 21.7304,
    rx: 3.14239,
    fill: "#DFDFDF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3196,
    cy: 15.5652,
    rx: 4.47391,
    ry: 4.47391,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.876 15.5653L14.0412 17.7793L14.0412 13.3513L17.876 15.5653Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5573 4.7C28.2928 4.7 29.6997 6.10689 29.6997 7.84239L29.6997 23.288C29.6997 25.0235 28.2928 26.4304 26.5573 26.4304L24.9062 26.4304L24.9062 4.7L26.5573 4.7Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09326 4.7L5.09326 26.4304L3.44217 26.4304C1.70668 26.4304 0.299782 25.0235 0.299782 23.288L0.299783 7.84239C0.299783 6.1069 1.70668 4.7 3.44217 4.7L5.09326 4.7Z",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.57812,
    y: 8.53481,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1846,
    y: 8.53481,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.57812,
    y: 14.287,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1846,
    y: 14.287,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.57812,
    y: 20.0391,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1846,
    y: 20.0391,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisabledVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/disabled-video.18ce3194abc483656656d0959908ce95.blank.svg";